import { useEffect, useState, useMemo } from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { getObjectsWithFilter } from '../../api/apiClientCrud'

function ListSelectField({ field, isTable, optionsAPI, onChangeF, dataId, error, isError, editRow, onRowDataChange }) {
  const [options, setOptions] = useState([])
  const [selectedValue, setSelectedValue] = useState(null)

  const filterObj = useMemo(() => optionsAPI.filter?.() ?? {}, [optionsAPI.filter])

  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      try {
        const res = await getObjectsWithFilter(optionsAPI.api, filterObj)
        const fetched = res.data?.[optionsAPI.api] ?? res.data
        if (isMounted) setOptions(fetched)
      } catch (err) {
        if (isMounted) setOptions([])
      }
    }

    fetchData()
    return () => {
      isMounted = false
    }
  }, [optionsAPI.api, filterObj])

  useEffect(() => {
    if (!editRow || !options.length) return

    const match = options.find((item) => item?.id === editRow[dataId])
    if (match && selectedValue?.id !== match.id) {
      setSelectedValue(match)
      const updatedRow = { ...editRow, [field.name]: match[field.returnField] }
      onRowDataChange(updatedRow)
    }
  }, [editRow, options, dataId, field.name, onRowDataChange, selectedValue])

  const handleChange = (_, newValue) => {
    const updatedRow = { ...editRow }

    if (newValue?.id) {
      updatedRow[dataId] = newValue.id
      setSelectedValue(newValue)
    } else {
      updatedRow[dataId] = null
      setSelectedValue(null)
    }

    onRowDataChange(updatedRow)
    onChangeF?.(updatedRow, options, onRowDataChange)
  }

  return (
    <Autocomplete
      disabled={field.enableEditing === false}
      options={options}
      value={selectedValue}
      getOptionLabel={(option) => option?.[field.optionLabel] ?? ''}
      onChange={handleChange}
      freeSolo={false}
      renderInput={(params) => (
        <TextField
          {...params}
          label={!isTable ? field.label : ''}
          variant='standard'
          error={isError}
          inputProps={{
            ...params.inputProps,
            onKeyDown: (e) => {
              if (e.key === 'Enter') {
                e.preventDefault()
                e.stopPropagation()
              }
            }
          }}
        />
      )}
    />
  )
}

export default ListSelectField
